/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {Box} from '@mui/material'
import React from 'react'
import Apps from '../startup-app/Apps'
import ChangeTheme from '../theme/ChangeTheme'
import {SxProps} from '@mui/system'
import QuickLaunchConfiguration from '../quicklaunch/QuickLaunchConfiguration'

const General: React.FC<{sx?: SxProps}> = ({sx}) => {
  return (
    <Box sx={sx} flexDirection={'column'}>
      <ChangeTheme />
      <QuickLaunchConfiguration />
      <Apps />
    </Box>
  )
}

export default General
